import e from "../managers/braze-instance.js";
import t from "../common/event-logger.js";
import { logger as r, EventTypes as i } from "../../shared-lib/index.js";
import tt from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as et } from "../triggers/triggers-provider-factory.js";
import {
  validateCustomProperties as ot,
  validateCustomString as rt,
} from "../util/validation-utils.js";
import { LOG_CUSTOM_EVENT_STRING as nt } from "../common/constants.js";
export function logCustomEvent(o, n) {
  if (!e.X()) return !1;
  if (null == o || o.length <= 0)
    return (
      r.error(
        `logCustomEvent requires a non-empty eventName, got "${o}". Ignoring event.`,
      ),
      !1
    );
  if (!rt(o, "log custom event", "the event name")) return !1;
  const [s, m] = ot(
    n,
    nt,
    "eventProperties",
    `log custom event "${o}"`,
    "event",
  );
  if (!s) return !1;
  const g = e.ir();
  if (g && g.me(o))
    return r.info(`Custom Event "${o}" is blocklisted, ignoring.`), !1;
  const f = t.q(i.CustomEvent, { n: o, p: m });
  if (f.L) {
    r.info(`Logged custom event "${o}".`);
    for (const t of f.ge) et.rr().fe(tt.ue, [o, n], t);
  }
  return f.L;
}
